module.exports = __webpack_public_path__ + "static/media/BTG.e406d5df.svg";